<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zbWTNS/tc-custom/9780253031303.jpg?1733042872797" alt="This image is the cover for the book Everyday Life in Global Morocco"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Everyday Life in Global Morocco
      </h1>
      <p class="bookDescription body article font2">
        <p>Following the story of one middle class family as they work, eat, love, and grow, Everyday Life in Global Morocco provides a moving and engaging exploration of how world issues impact lives. Rachel Newcomb shows how larger issues like gentrification, changing diets, and nontraditional approaches to marriage and fertility are changing what the everyday looks and feels like in Morocco. Newcomb's close engagement with the Benjelloun family presents a broad range of responses to the multifaceted effects of globalization. The lived experience of the modern family is placed in contrast with the traditional expectation of how this family should operate. This juxtaposition encourages new ways of thinking about how modern the notion of globalization really is. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rachel Newcomb
      </h2>
      
      <p class="authorDescription body article"><P>Rachel Newcomb is Professor of Anthropology at Rollins College in Winter Park, Florida. She is coeditor with David Crawford of Encountering Morocco: Fieldwork and Cultural Understanding (IUP).</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?71f77b25